import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Experience() {
  const {
    t
  } = useLanguage();
  const e = t.experience;
  return <section id="experience" aria-labelledby="experience-title" className="scroll-mt-20 bg-white py-24 md:py-32" data-id="element-79" data-mp="23qrbybuamifg">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-80" data-mp="1tv7idw37bvtv">
        <div className="self-start lg:sticky lg:top-28 lg:col-span-5" data-id="element-81" data-mp="2riq19zqkuebl">
          <p className="text-[14px] font-semibold text-violet" data-id="element-82" data-mp="2rfu104r9bdjz">{e.subtitle}</p>
          <h2 id="experience-title" className="mt-3 font-display text-[30px] font-medium leading-[1.2] tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-83" data-mp="2mjvbuey3trii">
            {e.title}
          </h2>
          <p className="mt-5 text-[17px] text-muted" data-id="element-84" data-mp="164u02xaf5bch">{e.intro}</p>
          <p className="mt-10 border-l-2 border-violet pl-5 font-serif text-[22px] italic leading-[1.45] text-ink" data-id="element-85" data-mp="166etukowsq9a">
            {e.emphasis}
          </p>
          <a href="#contact" className="btn btn-outline mt-10" data-id="element-86" data-mp="topzz06heghd">
            {e.cta}
          </a>
        </div>

        <ol className="lg:col-span-7" data-id="element-87" data-mp="yom4d0j3c9xg">
          {e.steps.map((step, i) => <li key={step.title} className="grid grid-cols-[52px_1fr] gap-x-4 border-t border-mist py-7 last:border-b md:grid-cols-[72px_1fr]" data-id="element-88" data-mp="jrbs3oymj00o" data-mpi={i}>
              <span aria-hidden="true" className="pt-1 font-display text-[14px] font-semibold tracking-[0.08em] text-violet" data-id="element-89" data-mp="ayrtgoic0vfu">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div data-id="element-90" data-mp="11n64lcr2txg">
                <h3 className="font-display text-[20px] font-medium text-ink" data-id="element-91" data-mp="12ezrqmsehl3">{step.title}</h3>
                <p className="mt-2 max-w-xl text-[16px] text-muted" data-id="element-92" data-mp="606o6ao83lkj">{step.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}